import { MapRef } from 'react-map-gl';

import { LatLong } from 'src/common/external/aws/suggestPois';

import { addLineStringSource } from './addLineStringSource';
import { addStringLineLayer } from './addStringLineLayer';

export function plotOrderedLocationsAsRouteLines(
  map: MapRef,
  uiRouteLayerId: string,
  orderLocations: LatLong[]
) {
  orderLocations.forEach((location, index) => {
    const nextLocation = orderLocations[index + 1];
    if (!nextLocation) return;
    const stringLineSourceId = `bambi-route-source-${uiRouteLayerId}`;
    const stringLineLayerId = `bambi-route-layer-${uiRouteLayerId}`;

    addLineStringSource(map, stringLineSourceId, location, nextLocation);
    addStringLineLayer(map, stringLineLayerId, stringLineSourceId);
  });
}
